module.exports = __webpack_public_path__ + "img/sameday_cod_k.15bd59e6.png";